import { JournalEntryParameterDto } from '../../../../cirabooks-module/_models/general-ledger/journal-entries/journal-entry-parameter-dto';

export class JournalEntryDetailParameterDto extends JournalEntryParameterDto {}
